import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_TOTAL_STATISTICS = 'FETCH_TOTAL_STATISTICS';
export const FETCH_TOTAL_STATISTICS_SUCCESS = 'FETCH_TOTAL_STATISTICS_SUCCESS';
export const FETCH_TOTAL_STATISTICS_FAIL = 'FETCH_TOTAL_STATISTICS_FAIL';

// Reducer
export default function totalStatisticsReducer(state = { data: {}, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_TOTAL_STATISTICS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_TOTAL_STATISTICS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_TOTAL_STATISTICS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchTotalStatistics(payload) {
  return { type: FETCH_TOTAL_STATISTICS, payload };
}

export function fetchTotalStatisticsSuccess(payload) {
  return { type: FETCH_TOTAL_STATISTICS_SUCCESS, payload };
}

export function fetchTotalStatisticsFail(payload) {
  return { type: FETCH_TOTAL_STATISTICS_FAIL, payload };
}

// Requests
export function requestFetchTotalStatistics() {
  return callApi('info/diagram_chats_stats/');
}

// Sagas
function* fetchTotalStatisticsSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchTotalStatistics);
    yield put(fetchTotalStatisticsSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchTotalStatisticsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* totalStatisticsSaga() {
  yield takeEvery(FETCH_TOTAL_STATISTICS, fetchTotalStatisticsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/totalStatistics.js